import { useLanguage } from '../context/LanguageContext';
import DashboardLayout from '../components/layout/DashboardLayout';
import { Mail, Phone, MessageCircle, HelpCircle } from 'lucide-react';

export default function SupportPage() {
  const { t } = useLanguage();

  return (
    <DashboardLayout>
      <div className="max-w-3xl" data-testid="support-page">
        <div className="mb-8">
          <h1 className="font-heading text-3xl font-bold text-primary mb-2">
            {t('support_title')}
          </h1>
          <p className="text-muted-foreground">
            {t('support_subtitle')}
          </p>
        </div>

        <div className="space-y-6">
          <div className="bg-card border border-border/50 rounded-2xl p-8">
            <h2 className="font-heading text-xl font-semibold text-primary mb-6">
              {t('support_contact_methods')}
            </h2>
            <div className="space-y-4">
              <div className="flex items-start gap-4 p-4 border border-border rounded-xl hover:bg-secondary/50 smooth-transition">
                <div className="w-12 h-12 rounded-full bg-accent/10 flex items-center justify-center flex-shrink-0">
                  <Mail className="h-6 w-6 text-accent" />
                </div>
                <div className="flex-1">
                  <h3 className="font-semibold text-primary mb-1">{t('support_email_title')}</h3>
                  <p className="text-sm text-muted-foreground mb-2">{t('support_email_desc')}</p>
                  <a href="mailto:support@prcremit.com" className="text-accent hover:underline text-sm font-medium">
                    support@prcremit.com
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4 p-4 border border-border rounded-xl hover:bg-secondary/50 smooth-transition">
                <div className="w-12 h-12 rounded-full bg-accent/10 flex items-center justify-center flex-shrink-0">
                  <Phone className="h-6 w-6 text-accent" />
                </div>
                <div className="flex-1">
                  <h3 className="font-semibold text-primary mb-1">{t('support_phone_title')}</h3>
                  <p className="text-sm text-muted-foreground mb-2">{t('support_phone_hours')}</p>
                  <a href="tel:+81-3-1234-5678" className="text-accent hover:underline text-sm font-medium">
                    03-1234-5678
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4 p-4 border border-border rounded-xl hover:bg-secondary/50 smooth-transition">
                <div className="w-12 h-12 rounded-full bg-accent/10 flex items-center justify-center flex-shrink-0">
                  <MessageCircle className="h-6 w-6 text-accent" />
                </div>
                <div className="flex-1">
                  <h3 className="font-semibold text-primary mb-1">{t('support_chat_title')}</h3>
                  <p className="text-sm text-muted-foreground mb-2">{t('support_chat_desc')}</p>
                  <button className="text-accent hover:underline text-sm font-medium">
                    {t('support_chat_start')}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-card border border-border/50 rounded-2xl p-8">
            <h2 className="font-heading text-xl font-semibold text-primary mb-6">
              {t('support_faq')}
            </h2>
            <div className="space-y-4">
              {[
                { q: t('support_faq_q1'), a: t('support_faq_a1') },
                { q: t('support_faq_q2'), a: t('support_faq_a2') },
                { q: t('support_faq_q3'), a: t('support_faq_a3') },
                { q: t('support_faq_q4'), a: t('support_faq_a4') },
              ].map((item, idx) => (
                <div key={idx} className="p-4 border border-border rounded-xl">
                  <div className="flex items-start gap-3 mb-2">
                    <HelpCircle className="h-5 w-5 text-accent flex-shrink-0 mt-0.5" />
                    <h3 className="font-medium text-primary">{item.q}</h3>
                  </div>
                  <p className="text-sm text-muted-foreground pl-8">{item.a}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
}
